import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const edit = {
	Id: null as number | null,
	TicketId: null as number | null,
	FirstName: null as string | null,
	MiddleName: null as string | null,
	LastName: null as string | null,
	EmailAdresa: null as string | null,
	Gender: null as string | null,
	TelMobNr: null as string | null,
	RegisteredMobile: null as string | null,
	RegisteredCity: null as string | null,
	RegisteredState: null as string | null,
	RegisteredPinCode: null as number | null,
	RegisteredPhone: null as string | null,
	ResidenceMobile: null as string | null,
	ResidenceCity: null as string | null,
	ResidenceState: null as string | null,
	ResidencePinCode: null as number | null,
	ResidencePhone: null as string | null,
	OfficeMobile: null as string | null,
	OfficeCity: null as string | null,
	OfficeState: null as string | null,
	OfficePinCode: null as number | null,
	OfficePhone: null as string | null,
	PartnerType: null as string | null,
	ManagerApprovalStatus: null as number | null,
	ManagerApprovalComment: null as string | null,
	UpdatedCustomerData: {
		VerifiedGenderText: null as string | null,
		VerifiedPartnerType: null as string | null,
		VerifiedFirstName: null as string | null,
		VerifiedMiddleName: null as string | null,
		VerifiedLastName: null as string | null,
		VerifiedEmailAdresa: null as string | null,
		VerifiedTelMobNr: null as string | null,
		VerifiedRegisteredMobile: null as string | null,
		VerifiedRegisteredCity: null as string | null,
		VerifiedRegisteredState: null as string | null,
		VerifiedRegisteredPinCode: null as number | null,
		VerifiedRegisteredPhone: null as string | null,
		VerifiedResidenceMobile: null as string | null,
		VerifiedResidenceCity: null as string | null,
		VerifiedResidenceState: null as string | null,
		VerifiedResidencePinCode: null as number | null,
		VerifiedResidencePhone: null as string | null,
		VerifiedOfficeMobile: null as string | null,
		VerifiedOfficeCity: null as string | null,
		VerifiedOfficeState: null as string | null,
		VerifiedOfficePinCode: null as number | null,
		VerifiedOfficePhone: null as string | null,
	},
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ManagerApprovalStatus: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
